import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Recipient } from '../../../types';
import { buildHeadersFromDocumentParams } from '../../documents/logic/buildHeadersFromDocumentParams';
import { DocumentParams } from '../../documents/types/DocumentParams';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const applyTemplateRoleContact = (
  constructGet: ConstructGet,
  roleId: string,
  documentParams: DocumentParams<'definition'>,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<Recipient> | undefined> =>
  constructGet<NonPaginatedResponse<Recipient>>(
    `${SIGNATURE_BASE_PATH}/apply-role/${roleId}`,
    { headers: buildHeadersFromDocumentParams(documentParams), params },
    { transformerSet: TransformerSet.PreserveKeys },
  );
